__turbopack_context__.v({
  "dot": "T3BrIG_dot",
  "spotsLeft": "T3BrIG_spotsLeft",
  "strikethroughPrice": "T3BrIG_strikethroughPrice",
  "tierText": "T3BrIG_tierText",
  "wrapper": "T3BrIG_wrapper",
});
